import css from './GSQRCodeModal.module.scss'
import React from 'react'
import QRCode from 'qrcode.react'

import { IGoodServiceTicketData } from 'meta/pages/goodsandservices'

import BalloonBox from 'components/TextBoxes/BalloonBox'

type Props = {
  data: IGoodServiceTicketData
}

const GSQRCodeModal: React.FC<Props> = (props) => {
  const { data } = props

  return (
    <div className={css.wrapper}>
      <BalloonBox infoType={'info'} fullWidth>
        <QRCode value={data.secret} size={173} />
      </BalloonBox>
    </div>
  )
}

export default GSQRCodeModal
